import { render, staticRenderFns } from "./KToolbar.vue?vue&type=template&id=3da94442"
import script from "./KToolbar.vue?vue&type=script&lang=js"
export * from "./KToolbar.vue?vue&type=script&lang=js"
import style0 from "./KToolbar.vue?vue&type=style&index=0&id=3da94442&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports